export default function Header() {
  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-slate-200 shadow-sm">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-3.5 flex items-center justify-between">
        <div className="flex items-center" data-testid="header-logo">
          <img src="/cliq-logo.png" alt="CLiQ! Booths" className="h-11 sm:h-12 w-auto" />
        </div>
        <span className="text-[10px] sm:text-xs font-bold tracking-[0.2em] text-slate-500 border border-slate-200 rounded-full px-3 py-1.5 bg-white">
          NYC &amp; LONG ISLAND
        </span>
      </div>
    </header>
  );
}
